import get from 'lodash/get'

export const notificationsInitialized = (state: any) => get(state, 'notification.initialized', false)
export const notifications = (state: any) => get(state, 'notification.notifications', [])
